import { createApi } from '@reduxjs/toolkit/query/react';
import {
  PromotionSlotsResponse,
  UpdatePromotionSlotRequest,
} from '../../types/promotionSlots';
import { baseQueryWithReauth } from './baseQuery';

export const promotionSlotsService = createApi({
  reducerPath: 'promotionSlotsService',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['PROMOTION_SLOTS'],
  endpoints: (builder) => ({
    getPromotionSlots: builder.query<PromotionSlotsResponse, void>({
      query: () => ({
        url: '/marketplace-service/v1/operator/promotion-slots',
        method: 'GET',
      }),
      providesTags: ['PROMOTION_SLOTS'],
    }),

    updatePromotionSlot: builder.mutation<
      { payload?: any; success?: boolean; message?: string },
      UpdatePromotionSlotRequest
    >({
      query: ({ id, slotNo }) => ({
        url: `/marketplace-service/v1/operator/promotion-slots/${id}`,
        method: 'PUT',
        body: { slotNo },
      }),
      invalidatesTags: ['PROMOTION_SLOTS'],
    }),
  }),
});

export const {
  useGetPromotionSlotsQuery,
  useUpdatePromotionSlotMutation,
} = promotionSlotsService;
